import { put, takeLatest } from "redux-saga/effects";
import { IFilterReferences } from "src/common/types";
import { getFilterReferences } from "../actions";

export function* fetchFilterReferencesList() {
  try {
    const data: IFilterReferences = yield getFilterReferences();

    yield put({
      payload: data,
      type: "GET_FILTER_REFERENCES_FULFILLED"
    });
  } catch (e) {
    // tslint:disable-next-line:no-console
    console.error(e);
    yield put({
      type: "GET_FILTER_REFERENCES_REJECTED"
    });
  }
}

export function* filterReferencesWatcher() {
  yield takeLatest("GET_FILTER_REFERENCES", fetchFilterReferencesList);
}
